
import {
  computed, defineComponent, reactive,
} from 'vue';
import { IEngenhariaControle, IEngenhariaEtapa } from '@/models/Entidades/Cadastros/PCP/IEngenhariaProduto';
import LancarMateriaPrimaEtapaProducao from './LancarMateriaPrimaEtapaProducao.vue';
import LancarProdutoAcabadoEtapaProducao from './LancarProdutoAcabadoEtapaProducao.vue';
import EngenhariaControle from './EngenhariaControle.vue';

export default defineComponent({
  name: 'EngenhariaEtapasProducao',
  props: {
    etapas: {
      type: Array as () => IEngenhariaEtapa[],
      required: true,
    },
    tipo: {
      type: Number,
      required: true,
    },
    empresas: {
      type: Array as () => number[],
      required: true,
    },
    codigoEngenharia: {
      type: Number,
      required: true,
    },
    controles: {
      type: Array as () => IEngenhariaControle[],
      required: true,
    },
    editavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LancarMateriaPrimaEtapaProducao,
    LancarProdutoAcabadoEtapaProducao,
    EngenhariaControle,
  },
  emits: ['update:etapas', 'update:engenharia'],
  setup(props, { emit }) {
    const state = reactive({
      indexSelecionado: 0,
      etapaSelecionada: 0,
      exibirProdutoAcabado: false,
      exibirMateriaPrima: false,
    });
    const computedEtapas = computed({
      get: () => props.etapas,
      set: (etapas: IEngenhariaEtapa[]) => {
        emit('update:etapas', etapas);
      },
    });

    const computedControle = computed({
      get: () => props.controles,
      set: (val: IEngenhariaControle[]) => {
        emit('update:engenharia', val);
      },
    });
    return {
      props,
      state,
      computedEtapas,
      computedControle,
    };
  },
});
